import * as React from "react";
import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import { Modal } from "@mui/material";
import {
  Fragment,
  PopupBody,
  PopupButton,
  PopupHeader,
  SectionTitle,
} from "./CommunicationPopups.styled";
import { PreAssesmentForm } from "./PreAssesmentForm";

export const CommunicationPopups = ({ open, onClose, data, classAPopupOpen, classBPopupOpen }) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <PopupBody>
        <Fragment>
          <PopupHeader>
            <Box>
              <SectionTitle>{classAPopupOpen ? `New Pre-assesment Communication` : `New Annual Meeting Notice Communication`}</SectionTitle>
            </Box>
            <PopupButton aria-label="close" onClick={onClose}>
              <CloseIcon />
            </PopupButton>
          </PopupHeader>
          <Box
            sx={{
              p: 1,
            }}
          >
            <PreAssesmentForm onClose={onClose} data={data} type={classAPopupOpen ? 1 : 2} />
          </Box>
        </Fragment>
      </PopupBody>
    </Modal>
  );
};
